module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ce4b7756c3d8b5c5e32aa1a0c93d22a5.png";